module.exports = __webpack_public_path__ + "img/position-dist.fa87c2e9.svg";